import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";

import { hashFromObj } from "../lib/utils/hash";

import { normalize, Schema, arrayOf } from "normalizr";

const offer = new Schema("offers", { idAttribute: "slug" });

const State = Record(
  {
    map: Map(),
    results: Map(),
    meta: new (Record(
      {
        currentPage: 1,
        limit: 10,
        offset: 0,
        sortDir: "asc",
        sortField: "start_date",
        searchHash: "",
      },
      "meta"
    ))(),
    search: new (Record(
      {
        general: "",
        localization: "",
        sex: "",
        agencyUID: "",
      },
      "search"
    ))(),
    isSent: false,
    form: new (Record(
      {
        loading: false,
        error: null,
      },
      "form"
    ))(),
  },
  "offer"
);

const offersReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.GET_OFFERS_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, { offers: arrayOf(offer) });

      delete data.search;

      return state
        .update("map", (map) => map.merge(nrs.entities.offers))
        .update("results", (rs) => rs.set(hashFromObj(data), nrs.result));
    }

    case actions.GET_OFFER_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, offer);
      return state.update("map", (map) => map.merge(nrs.entities.offers));
    }

    case actions.GET_OFFER_BY_KEY_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, offer);
      return state.update("map", (map) => map.merge(nrs.entities.offers));
    }

    case actions.SET_OFFER_PAGE: {
      const { page } = action.payload;
      const limit = state.getIn(["meta", "limit"]);
      return state
        .setIn(["meta", "currentPage"], page)
        .setIn(["meta", "offset"], (page - 1) * limit);
    }

    case actions.SET_OFFER_SORT: {
      const { field, dir } = action.payload;
      return state
        .setIn(["meta", "sortDir"], dir)
        .setIn(["meta", "sortField"], field);
    }

    case actions.SET_OFFER_SEARCH_FIELD: {
      const { field, value } = action.payload;
      return state.setIn(["search", field], value);
    }

    case actions.CREATE_OFFER: {
      return state.setIn(["form", "loading"], true).setIn(["isSent"], false);
    }

    case actions.CREATE_OFFER_SUCCESS: {
      return state.setIn(["form", "loading"], false).setIn(["isSent"], true);
    }

    case actions.CREATE_OFFER_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "loading"], false);
    }

    case actions.CREATE_OFFER_FINALLY: {
      return state.setIn(["form", "loading"], false);
    }

    case actions.OFFER_CLEAR_ERROR: {
      const { field } = action.payload;

      let errors =
        state.form.error && state.form.error && state.form.error.errors;
      if (errors && errors[field]) {
        errors[field] = undefined;
      }

      return state.setIn(["form", "error"], new ValidationError(errors));
    }

    case actions.OFFER_CLEAR_FORM: {
      const { clearSentStatus } = action.payload;
      if (!clearSentStatus) {
        state = state.setIn(["isSent"], false);
      }

      return state.setIn(["form", "error"], null);
    }

    case actions.GENERATE_OFFER_SEARCH_HASH: {
      const hash = hashFromObj(state.get("search").toJS());
      return state.setIn(["meta", "searchHash"], hash);
    }

    default:
      return state;
  }
};

export default offersReducer;



/** WEBPACK FOOTER **
 ** ./src/common/offer/reducer.js
 **/